export default {
  methods: {
    pathJoin(parts) {
      if (!parts.length) return ''

      let protocol = ''
      const protocolIndex = parts[0].indexOf('//')
      if (protocolIndex !== -1) {
        protocol = parts[0].substring(0, protocolIndex + 2)
        parts[0] = parts[0].substring(protocolIndex + 2, parts[0].length)
      }

      const separator = '/'
      const replace = new RegExp(separator + '{1,}', 'g')
      return protocol + parts.join(separator).replace(replace, separator)
    },
    areLocalHost() {
      const subdomain = window.location.host.split('.')[0]

      if (subdomain.indexOf('localhost') !== -1) {
        return true
      } else {
        return false
      }
    }
  }
}
